module.exports = __webpack_public_path__ + "img/contact1.0ad31903.jpg";